import { render, staticRenderFns } from "./Viaje.vue?vue&type=template&id=51e987c9&scoped=true"
import script from "./Viaje.vue?vue&type=script&lang=js"
export * from "./Viaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e987c9",
  null
  
)

export default component.exports